import { render, staticRenderFns } from "./DashboardSalesTrendWidget.vue?vue&type=template&id=3fd5da0c&"
import script from "./DashboardSalesTrendWidget.vue?vue&type=script&lang=js&"
export * from "./DashboardSalesTrendWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports